import React from "react";
import { motion } from "framer-motion";

export default function NoEnemigoSection() {
  return (
    <section
      id="no-enemigo"
      className="section-cream relative py-24 md:py-36 overflow-hidden"
      data-testid="no-enemigo-section"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start"
        >
          <div className="lg:col-span-6">
            <p className="overline mb-6">◇ No es tu enemigo</p>
            <h2 className="font-serif font-normal text-4xl sm:text-5xl lg:text-6xl text-[#0B0E13] leading-[1.05] tracking-[-0.01em]">
              El personaje no es tu enemigo.
              <br />
              <span className="italic text-[#6E7580]">Es tu maestro.</span>
            </h2>
            <div className="gold-divider mt-8" />
          </div>

          <div className="lg:col-span-6 space-y-6">
            <p className="text-[#2A303A] text-lg md:text-xl leading-[1.7] font-light font-sans">
              No se trata de destruirlo, de vencerlo, ni de convertirlo en algo malo. Se trata
              de <span className="font-serif italic text-[#0B0E13]">verlo</span>. De reconocerle
              lo que hizo por ti. Y de decidir, con conciencia, que ya no tiene que dirigir.
            </p>
            <p className="text-[#2A303A] text-lg md:text-xl leading-[1.7] font-light font-sans">
              La transformación real no llega desde la lucha contra ti mismo. Llega cuando
              comprendes qué te ha estado dirigiendo, por qué apareció y qué está tratando de
              protegerte todavía.
            </p>
            <p className="font-serif italic text-[#0B0E13] text-2xl md:text-3xl leading-[1.35] tracking-[-0.005em]">
              Comprender es importante.
              <br />
              <span className="text-[#8E7A55]">Integrar el cambio es otra cosa.</span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
